import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./historical2-schedules-view.html';
import DataProvider from "../../../app/data-framework/data-provider";

    function HistoricalSchedulesView(params) {
        var self = this;

        self.route = params.route;
        self.dataProvider = DataProvider.getInstance();
        self.appId = params.appId;

    }

  // This runs when the component is torn down. Put here any logic necessary to clean up,
  // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    HistoricalSchedulesView.prototype.dispose = function () { };
  
    export default { viewModel: HistoricalSchedulesView, template: templateMarkup };


